module.exports = __webpack_public_path__ + "img/crusher1.9f65b331.png";